import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { WaitImageComponent } from 'app/shared/components/wait-image.component/wait-image.component';
import { ComponentInfoComponent } from 'app/shared/components/component-info.component/component-info.component';
import { CancelWarningsTableComponent } from 'app/shared/components/cancel-warnings-table.component/cancel-warnings-table.component';
import { NumeralPipe } from 'app/shared/pipes/numeral.pipe';
import { SafeHtmlPipe } from 'app/shared/pipes/safe-HTML.pipe';
import {PeriodSelectorComponent} from "./components/period-selector.component/period-selector.component";
import {CloseBtnComponent} from "./components/close-btn.component/close-btn.component";
import {BackgroundBtnComponent} from "./components/background-btn.component/background-btn.component";
import {UniversalListComponent} from "./components/universal-list.component/universal-list.component";
//import {SlickGridModule2} from "../slick-grid-23/slick-grid.module";
import {SlickGridModule} from "../slick-grid/slick-grid.module";
import {DraggableDirective} from "./directives/draggable.directive";
import {MovableDirective} from "./directives/movable.directive";
import {SortableDirective} from "./directives/sortable.directive";
import {MovableAreaDirective} from "./directives/movable-area.directive";
import {SortableListDirective} from "./directives/sortable-list.directive";
import {DraggableHelperDirective} from "./directives/draggable-helper.directive";
import {BootstrapTooltipDirective} from "./directives/bootstrap-tooltip.directive";
import {StocksToolbarComponent} from "./components/stocks-toolbar.component/stocks-toolbar.component";
import {StocksModule} from "../stocks/stocks.module";
import {AgSelectListComponent} from "../stocks/components/ag-select-list.component/ag-select-list.component";
import {AggregationListComponent} from "../stocks/components/aggregations-list.component/aggregations-list.component";
import {SimpleMenuComponent} from "./components/simple-menu.component/simple-menu.component";
import {ChangeFocusDirective} from "./directives/change-focus.directive";

@NgModule({
    imports: [CommonModule, TranslateModule.forChild(), FormsModule, SlickGridModule, OverlayModule],
    declarations: [
        WaitImageComponent,
        NumeralPipe,
        SafeHtmlPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent,
        PeriodSelectorComponent,
        CloseBtnComponent,
        BackgroundBtnComponent,
        //UniversalListComponent,
        DraggableDirective,
        MovableDirective,
        MovableAreaDirective,
        DraggableHelperDirective,
        SortableDirective,
        SortableListDirective,
        BootstrapTooltipDirective,
        StocksToolbarComponent,
        AgSelectListComponent,
        AggregationListComponent,
        SimpleMenuComponent,
        ChangeFocusDirective
    ],
    exports: [
        WaitImageComponent,
        NumeralPipe,
        SafeHtmlPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent,
        PeriodSelectorComponent,
        CloseBtnComponent,
        BackgroundBtnComponent,
        //UniversalListComponent,
        DraggableDirective,
        MovableDirective,
        MovableAreaDirective,
        DraggableHelperDirective,
        SortableDirective,
        SortableListDirective,
        BootstrapTooltipDirective,
        StocksToolbarComponent,
        AgSelectListComponent,
        AggregationListComponent,
        SimpleMenuComponent,
        ChangeFocusDirective
    ]
})
export class SharedModule {
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts